import {
  RDX_APP_API_START,
  RDX_APP_API_END,
  RDX_APP_API_FINISH,
  RDX_APP_SAAS_START,
  RDX_APP_SAAS_END,
  RDX_APP_SAAS_PENDING,
  RDX_APP_MODULE_START,
  RDX_APP_MODULE_END,
  RDX_APP_LOGON,
  RDX_APP_LOGON_FREQUENCY,
  RDX_APP_SAAS,
  RDX_APP_LOGOUT,
  RDX_APP_SESSIONTIMEOUT_OPEN,
  RDX_APP_SESSIONTIMEOUT_RESET,
  RDX_APP_LOADING_TEXT_SHOWING,
} from './appAction';

const initial = {
  apiInflight: 1,
  showLoadingText: false,
  saasInflight: 'end',
  moduleLoaded: false,
  logonState: '',
  timeoutResetTime: undefined,
  saasLogonfrequency: 0,
};

const app = (state = initial, action) => {
  let newState = {...state};
  switch (action.type) {
    case RDX_APP_API_START:
      newState.apiInflight++;
      return newState;
    case RDX_APP_API_END:
      newState.apiInflight--;
      if (newState.apiInflight < 0) {
        newState.apiInflight = 0;
      }
      return newState;
    case RDX_APP_API_FINISH:
      newState.apiInflight = 0;
      return newState;
    case RDX_APP_SAAS_START:
      newState = {...state, saasInflight: 'start'};
      return newState;
    case RDX_APP_SAAS_PENDING:
      newState = {...state, saasInflight: 'pending'};
      return newState;
    case RDX_APP_SAAS_END:
      newState = {...state, saasInflight: 'end'};
      return newState;
    case RDX_APP_MODULE_START:
      newState.moduleLoaded = false;
      return newState;
    case RDX_APP_MODULE_END:
      newState.moduleLoaded = true;
      return newState;
    case RDX_APP_LOGON:
      newState.logonState = action.logonState;
      return newState;
    case RDX_APP_LOGON_FREQUENCY:
      newState = {...state, saasLogonfrequency: action.saasLogonfrequency};
      return newState;
    case RDX_APP_SAAS:
      newState.saasLogonfrequency = action.saasLogonfrequency;
      return newState;
    case RDX_APP_LOGOUT:
      return state;
    case RDX_APP_LOADING_TEXT_SHOWING:
      newState = {...state, showLoadingText: action.enableIndicator};
      return newState;
    case RDX_APP_SESSIONTIMEOUT_OPEN:
      return {...newState, timeoutResetTime: 0};
    case RDX_APP_SESSIONTIMEOUT_RESET:
      return {...newState, timeoutResetTime: new Date().getTime()};
    default:
      return state;
  }
};

export default app;
